import firebase from '@firebase/app';
import 'firebase/firestore';
require('firebase/auth');




// const firebaseConfig = {
//   apiKey: "AIzaSyCYrEi7dBqgTQv6AJJIYyyR1m7zfPKEiKE",
//   authDomain: "hci-msntest.firebaseapp.com",
//   projectId: "hci-msntest",
//   storageBucket: "hci-msntest.appspot.com",
//   messagingSenderId: "875032650949",
//   appId: "1:875032650949:web:87100574fa448148333cac"
// };

// const firebaseConfig = {
//   apiKey: "AIzaSyAM9Bgw5d3MmRpMLJKaOsFfGpJKXDs8XtY",
//   authDomain: "msn-project-dc772.firebaseapp.com",
//   projectId: "msn-project-dc772",
//   storageBucket: "msn-project-dc772.appspot.com",
//   messagingSenderId: "743609196904",
//   appId: "1:743609196904:web:a232471229c836fdbaf6dd",
//   measurementId: "G-2201ZKVP3N"
// };


// const firebaseConfig = {
//   apiKey: "AIzaSyAM9Bgw5d3MmRpMLJKaOsFfGpJKXDs8XtY",
//   authDomain: "msn-project-dc772.firebaseapp.com",
//   projectId: "msn-project-dc772",
//   storageBucket: "msn-project-dc772.appspot.com",
//   messagingSenderId: "743609196904",
//   appId: "1:743609196904:web:69b3dba806bb6260baf6dd",
//   measurementId: "G-8JVWDD4E3P"
// };

// const firebaseConfig = {
//   apiKey: "AIzaSyDHKI9MKNOrdZJXGWkqBlerK9fo3xy0zQU",
//   authDomain: "msn-revision-ba268.firebaseapp.com",
//   projectId: "msn-revision-ba268",
//   storageBucket: "msn-revision-ba268.appspot.com",
//   messagingSenderId: "885539107668",
//   appId: "1:885539107668:web:158a41904f89ffa6a54ec1",
//   measurementId: "G-0VR69Z54QB"
// };

const firebaseConfig = {
  apiKey: "AIzaSyC3EFrW6Q_-jgpecw3gc9IgpoWWj1ImLKE",
  authDomain: "msntask-simple-bagel.firebaseapp.com",
  projectId: "msntask-simple-bagel",
  storageBucket: "msntask-simple-bagel.appspot.com",
  messagingSenderId: "948081866204",
  appId: "1:948081866204:web:48593c3d11c9f14c128b19",
  measurementId: "G-K7HH3EFFYG"
};

firebase.initializeApp(firebaseConfig);
export default firebase;
